import React, { useMemo } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useInstantSearch } from 'react-instantsearch';
import { Button as RKSButton, FormikWrapper } from '@uncinc/uncinc-react-kitchen-sink';
import useLoading from '../../hooks/useLoading';
import { DEFAULT_TEXT, getDefaultText } from '../../config/constants';
import { mapFacetsToValues, mapValuesToFacets } from './helpers';
const SearchFacets = props => {
  var _results$nbHits;
  const {
    t
  } = useTranslation();
  const {
    results,
    indexUiState
  } = useInstantSearch();
  const {
    isLoading
  } = useLoading();
  const {
    autoSubmit = true,
    submitButton,
    submitButtonText = t(['searchkit.buttons.refine', getDefaultText(DEFAULT_TEXT.BUTTONS.REFINE, 'count', (results === null || results === void 0 || (_results$nbHits = results.nbHits) === null || _results$nbHits === void 0 ? void 0 : _results$nbHits.toString()) || '0')], {
      count: results.nbHits
    }),
    className,
    children,
    onSubmit
  } = props;
  const classNames = c('Searchkit__Facets', className);
  const Button = submitButton || RKSButton;
  const initialValues = useMemo(() => mapFacetsToValues(indexUiState), [indexUiState]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement(FormikWrapper, {
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: values => {
      if (autoSubmit || !onSubmit) {
        return;
      }
      onSubmit(mapValuesToFacets(values));
    }
  }, children, !autoSubmit && /*#__PURE__*/React.createElement(Button, {
    htmlType: "submit",
    className: "Searchkit__Facets__submit",
    isLoading: isLoading
  }, submitButtonText)));
};
export default SearchFacets;